// Course/CourseLesson.tsx
import React from 'react';

import {ICourseLesson} from "../../Types/psychology/course";
import {useTheme} from "Theme/ThemeContext";
import {FC} from "WideLayout/Layouts";

interface CourseLessonProps {
    lesson: ICourseLesson;
    isPublic?: boolean;
}

const CourseLesson: React.FC<CourseLessonProps> = ({lesson, isPublic}) => {
    const {plt} = useTheme();
    return (
        <div className="course-lesson-content fc gap-2" style={{color: plt.text.primary60}}>
            {lesson.accessed || isPublic ? (
                <FC>
                    <p style={{whiteSpace: 'pre-wrap'}} className="course-lesson-description">
                        {lesson.description}
                    </p>

                    {lesson.youtube_embed_code && (
                        <iframe
                            style={{
                                aspectRatio: '4 / 2',
                                borderRadius: '1.66rem'
                            }}
                            className="course-lesson-video"
                            src={`https://www.youtube.com/embed/${lesson.youtube_embed_code}`}
                            allowFullScreen
                            title={lesson.name}
                        />
                    )}

                    {lesson.rutube_embed_code && (
                        <iframe
                            style={{
                                aspectRatio: '4 / 2',
                                borderRadius: '1.66rem',
                                marginTop: '1rem'
                            }}
                            className="course-lesson-video-rutube"
                            src={`https://rutube.ru/play/embed/${lesson.rutube_embed_code}`}
                            allowFullScreen
                            title={lesson.name}
                        />
                    )}
                </FC>
            ) : (
                <FC>Для доступа к этому уроку купите курс.</FC>
            )}
        </div>
    );
};

export default CourseLesson;
